module.exports = __webpack_public_path__ + "static/media/seeker-empty.a264d0c7.png";